import { render, staticRenderFns } from "./customer_private_seas_detail.vue?vue&type=template&id=37cb6c1c&scoped=true&"
import script from "./customer_private_seas_detail.vue?vue&type=script&lang=js&"
export * from "./customer_private_seas_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_private_seas_detail.vue?vue&type=style&index=0&id=37cb6c1c&prod&lang=scss&scoped=true&"
import style1 from "./customer_private_seas_detail.vue?vue&type=style&index=1&id=37cb6c1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb6c1c",
  null
  
)

export default component.exports